// @ds/forms/parseJsonFieldValues — json-widget submit parse.
//
// `json`-typed widgets (fieldTypeRegistry → JsonTextArea) emit the RAW
// textarea string — emitting parsed objects on change would re-stringify
// (and reformat) the text under the caret. The parse to a jsonb-ready value
// happens here, once, at submit (SchemaForm's onFinish pipeline): input that
// parses as JSON becomes the parsed value; input that doesn't is kept as the
// raw string (a jsonb column stores plain strings too — the
// `appConfigDao.setKey` semantic).

export function parseJsonFieldValues(
  values: Record<string, unknown>,
  schema: Record<string, { edit?: { key?: string; field?: { type?: string } } }>,
): Record<string, unknown> {
  let out = values;
  for (const field of Object.values(schema)) {
    const edit = field?.edit;
    if (edit?.field?.type !== "json" || !edit.key) continue;
    const raw = out[edit.key];
    if (typeof raw !== "string") continue;
    let parsed: unknown = raw;
    try {
      parsed = JSON.parse(raw);
    } catch {
      /* not JSON — keep the raw string */
    }
    if (out === values) out = { ...values };
    out[edit.key] = parsed;
  }
  return out;
}
